<template>
  <div>
    <div class="left">
      <div class="filtrate">
        <div class="address hp_cz_center_s">
          <div class="address_left hp_cz_center">
            <icon-font
              style="font-size:30px;color:#0079FE;"
              type="icon-dingwei2"
            />
            <span>安徽 淮南</span>
          </div>
          <div class="address_right">
            共
            <span>{{ total }}</span>
            家医院
          </div>
        </div>
        <div class="hospitalTypes">
          <div class="lv hp_flex">
            <div class="first">医院等级</div>
            <div class="tag-box">
              <div
                @click="selChange(0, index)"
                :class="{ active: item.selected }"
                v-for="(item, index) in HOSP_LEVEL"
                :key="index"
                class="tag"
              >{{ item.text }}</div>
            </div>
          </div>
          <div class="lv hp_flex">
            <div class="first">医院类型</div>
            <div class="tag-box">
              <div
                @click="selChange(1, index)"
                v-for="(item, index) in HOSP_TYPE"
                :key="index"
                :class="{ active: item.selected }"
                class="tag"
              >{{ item.text }}</div>
            </div>
          </div>
          <div class="lv hp_flex">
            <div class="first">行政级别</div>
            <div class="tag-box">
              <div
                @click="selChange(2, index)"
                v-for="(item, index) in HOSP_ADMIN"
                :key="index"
                :class="{ active: item.selected }"
                class="tag"
              >{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="list && list.length > 0">
        <hospitalDemo :list="list"></hospitalDemo>
        <div>
          <a-pagination
            show-quick-jumper
            :current="currPage"
            :total="totalCount"
            :defaultPageSize="form.pageSize"
            @change="onChange"
          />
        </div>
      </template>
      <noData v-else></noData>
    </div>
  </div>
</template>
<script>
import hospitalDemo from "./components/demo";
import { ls } from "@/utils/tool";
import { getTotalCount, getHospitals } from "@/api/registered";
import noData from "@/components/NoData";
export default {
  components: {
    hospitalDemo,
    noData,
  },
  data() {
    return {
      HOSP_LEVEL: [],
      HOSP_TYPE: [],
      HOSP_ADMIN: [],
      total: "",
      list: [],
      form: {
        level: "",
        type: "",
        adminLevel: "",
        pageNum: 1,
        pageSize: 6,
        pcReqFlag: true,
        registPage: true,
      },
      currPage: 1,
      totalCount: 1,
    };
  },
  mounted() {
    this.selList();
    this.initTotal();
    this.init();
  },
  methods: {
    onChange(pageNumber) {
      this.form.pageNum = pageNumber;
      this.init();
    },
    async init() {
      var res = await getHospitals(this.form);
      console.log("res====", res);
      this.list = res.data.list;
      this.totalCount = res.data.totalCount;
      this.currPage = res.data.currPage;
    },
    async initTotal() {
      var res = await getTotalCount();
      this.total = res.data;
    },
    selChange(num, index) {
      if (num === 0) {
        this.HOSP_LEVEL[index].selected = !this.HOSP_LEVEL[index].selected;
        this.form.level = "";
        var level = [];
        this.HOSP_LEVEL.forEach((item) => {
          if (item.selected) {
            level.push(item.value);
          }
        });
        this.form.level = level.toString();
      } else if (num === 1) {
        this.HOSP_TYPE[index].selected = !this.HOSP_TYPE[index].selected;
        this.form.type = "";
        var type = [];
        this.HOSP_TYPE.forEach((item) => {
          if (item.selected) {
            type.push(item.value);
          }
        });
        this.form.type = type.toString();
      } else if (num === 2) {
        this.HOSP_ADMIN[index].selected = !this.HOSP_ADMIN[index].selected;
        this.form.adminLevel = "";
        var adminLevel = [];
        this.HOSP_ADMIN.forEach((item) => {
          if (item.selected) {
            adminLevel.push(item.value);
          }
        });
        this.form.adminLevel = adminLevel.toString();
      }
      this.form.pageNum = 1;
      this.init();
    },
    selList() {
      this.HOSP_LEVEL = ls.get("HOSP_LEVEL").map((item) => {
        return { ...item, selected: false };
      });
      this.HOSP_TYPE = ls.get("HOSP_TYPE").map((item) => {
        return { ...item, selected: false };
      });
      this.HOSP_ADMIN = ls.get("HOSP_ADMIN").map((item) => {
        return { ...item, selected: false };
      });
    },
  },
};
</script>
<style lang="less" scoped>
.left {
  width: 911px;
  .filtrate {
    border-radius: 10px;
    overflow: hidden;
    box-shadow: -2px 0px 6px 1px #b5d2f7;

    margin-bottom: 23px;
    .tag-box {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
    }
    .address {
      padding-left: 24px;
      padding-right: 30px;
      height: 60px;
      background: #e7f2ff;
      .address_left {
        span {
          color: #333333;
          font-size: 16px;
        }
      }
      .address_right {
        color: #333333;
        font-size: 16px;
        span {
          color: #0079fe;
          font-size: 20px;
          font-weight: Bold;
        }
      }
    }
    .hospitalTypes {
      font-size: 16px;
      padding: 22px;
      padding-bottom: 10px;
      .first {
        padding-right: 20px;
        // border-right: 2px solid #f3f3f3;
        margin-right: 20px;
        font-weight: bold;
      }
      .lv {
        flex-wrap: wrap;
        .tag {
          cursor: pointer;
          color: #0079fe;
          margin-right: 39px;
          margin-bottom: 18px;
        }
        .active {
          color: #ff4d4f;
        }
      }
      .lv:not(:first-child) {
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
